import React, { Fragment } from "react";
import {
  PlusCircleIcon,
  XMarkIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import { Dialog, Transition } from "@headlessui/react";
import IconButton from "../../../iconButton";

const AdminCourseSlideOver = ({ show, setShowSlide, handleClose, type }) => {
  const professionalData = [
    {
      id: 1,
      text: "Private Doctors",
    },
    {
      id: 2,
      text: "Private Doctors",
    },
    {
      id: 3,
      text: "Private Doctors",
    },
    {
      id: 4,
      text: "Private Doctors",
    },
    {
      id: 5,
      text: "Private Doctors",
    },
    {
      id: 6,
      text: "Private Doctors",
    },
    {
      id: 7,
      text: "Private Doctors",
    },
    {
      id: 8,
      text: "Private Doctors",
    },
    {
      id: 9,
      text: "Private Doctors",
    },
    {
      id: 10,
      text: "Private Doctors",
    },
  ];
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden dashboard_calander_slideover">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full px-[15px] py-5 md:p-0">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[478px]">
                  <div className="flex h-full flex-col bg-white py-5 md:pt-10 md:pb-5 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
                    <div className="border-b border-solid border-[#CCD0D4] pb-3 md:pb-[30px] mb-4 md:mb-6">
                      <div className="flex items-center justify-between mb-2 md:mb-5">
                        <Dialog.Title className="text-xl md:text-2xl font-bold leading-[160%] text-[#04091E]">
                          {type} a Course
                        </Dialog.Title>
                        <XMarkIcon
                          className="w-6 h-6 cursor-pointer text-black hover:text-red-700"
                          onClick={handleClose}
                        />
                      </div>
                      <p className="text-sm md:text-base font-normal leading-[160%] text-[#485868]">
                        Write your reasons for approving this credit refund
                        request as necessary.
                      </p>
                    </div>
                    <form className="scroller max-h-[620px] overflow-y-auto pr-1 mb-[30px] dark-field">
                      <div className="mb-[22px]">
                        <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-3 block">
                          Course Name
                        </label>
                        <input
                          type="text"
                          placeholder="ex. HelpMatch Orientation Training"
                          className="p-5 rounded-[10px] border border-strokeColor text-sm md:text-lg font-medium leading-[160%] text-customGray placeholder:text-[#A7AFB7] placeholder:font-bold h-12 md:h-[70px]"
                        />
                      </div>
                      <div className="mb-[22px]">
                        <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-3 block">
                          Course Tile Description
                        </label>
                        <textarea
                          placeholder="Course Description...s"
                          className="block w-full p-4 md:py-5 md:px-[30px] rounded-[10px] border border-strokeColor min-h-[120px] md:min-h-[147px] resize-none outline-none text-sm md:text-lg font-medium leading-[160%] text-customGray placeholder:text-[#A7AFB7]"
                        ></textarea>
                      </div>
                      <div className="mb-[22px]">
                        <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-3 block">
                          Course Heading
                        </label>
                        <input
                          type="text"
                          placeholder="ex. Welcome to the Training!"
                          className="p-5 rounded-[10px] border border-strokeColor text-sm md:text-lg font-medium leading-[160%] text-customGray placeholder:text-[#A7AFB7] placeholder:font-bold h-12 md:h-[70px]"
                        />
                      </div>
                      <div className="mb-[22px]">
                        <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-3 block">
                          Course Description
                        </label>
                        <textarea
                          placeholder="Course Description..."
                          className="block w-full p-4 md:py-5 md:px-[30px] rounded-[10px] border border-strokeColor min-h-[120px] md:min-h-[147px] resize-none outline-none text-sm md:text-lg font-medium leading-[160%] text-customGray placeholder:text-[#A7AFB7]"
                        ></textarea>
                      </div>
                      <div className="">
                        <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-3 block">
                          Professions
                        </label>
                        <div className="grid grid-cols-1 md:grid-cols-2">
                          {professionalData.map((item) => (
                            <div
                              className={`form-group relative flex items-center pl-1 transition-all duration-300 ease-in cursor-pointer mb-3`}
                              //   onClick={handleDivClick}
                            >
                              <input
                                id={`option-${item.id}`}
                                aria-describedby="comments-description"
                                name={`option-${item.id}`}
                                type="checkbox"
                                // checked={isOptionSelected}
                                // onChange={handleCheckboxChange}
                                className="rounded border border-solid border-[#CCD0D4] relative cursor-pointer inline-block w-5 h-5 leading-[0px]"
                              />
                              <div className="min-w-0 flex-1 text-sm leading-6">
                                <label htmlFor={`option-${item.id}`} className="font-medium text-customGray text-sm md:text-base leading-[160%] pl-[14px] cursor-pointer">
                                  {item.text}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </form>
                    {type != "Edit" ? (
                      <div className="grid grid-cols-2 gap-5">
                        <IconButton
                          title="cancel"
                          icon={XCircleIcon}
                          classes={`mb-5 md:mb-0 flex items-center bg-[#EBEFF3] text-sm md:text-base rounded-[10px] font-black uppercase text-[#485868] leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer`}
                          onClick={handleClose}
                          iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                        />
                        <IconButton
                          title="create"
                          icon={PlusCircleIcon}
                          classes={`mb-5 md:mb-0 flex items-center bg-primary text-sm md:text-base rounded-[10px] text-white font-black uppercase leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer`}
                          onClick={handleClose}
                          iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                        />
                      </div>
                    ) : (
                      <div className="grid grid-cols-2 gap-5">
                        <IconButton
                          title="Delete"
                          icon={XCircleIcon}
                          classes={`mb-5 md:mb-0 flex items-center bg-white text-sm md:text-base rounded-[10px] text-[#EF2121] font-black uppercase leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer border border-[#EF2121]`}
                          onClick={handleClose}
                          iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                        />
                        <IconButton
                          title="update"
                          icon={type === "Deny" ? XCircleIcon : CheckCircleIcon}
                          classes={`mb-5 md:mb-0 flex items-center bg-primary text-sm md:text-base rounded-[10px] text-white font-black uppercase leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer`}
                          onClick={handleClose}
                          iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                        />
                      </div>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AdminCourseSlideOver;
